.root {
  align-items: center;
  background: none;
  border: none;
  border-radius: 6px;
  color: inherit;
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  gap: 4px;
  padding: 4px 8px;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background: var(--color-secondary);
    color: var(--color-foreground);
  }

  &:hover .icon {
    opacity: 1;
  }
}

.icon {
  color: var(--color-foreground);
  flex-shrink: 0;
  height: 16px;
  transition: opacity 0.15s;
  width: 16px;
}

.iconActive {
  color: var(--color-foreground);
  flex-shrink: 0;
  height: 16px;
  width: 16px;
}
